export default "__VITE_ASSET__ca92471e__"